// extracted by mini-css-extract-plugin
export default {"top__spacing":"PageLayout_top__spacing__pbsHk"};